export default {"src":"/_next/static/media/step-1.a0e88b23.svg","height":23,"width":8};